//@flow
import React, {useEffect, useMemo, useState} from 'react';
import {Typography, makeStyles} from '@material-ui/core';
import YoutubePlayer from 'react-youtube';

import {colors} from '../../../../../../../assets/styles/colors';
import CustomTextField from '../../../../../../../elements/CustomTextField/CustomTextField';
import {useFormContext} from 'react-hook-form';
import {MAIN_BANNER_FIELDS} from '../constants';
import {extractYoutubeVideoId} from '../../../../../../../utils/youtube';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    maxWidth: '1200px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',

    padding: '.75rem 0',
  },
  backButton: {
    background: 'white',
    padding: '4px',
    margin: '0 16px 0 0',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  title: {
    fontSize: '1rem',
    fontWeight: '600',
    color: colors.grey900,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    // height: '100%',
    gap: '1rem',
    position: 'relative',
    // padding: '1rem',
    borderRadius: '12px',
    background: 'white',
    // maxWidth: '800px',
    /*   boxShadow:
      '0px 0.5px 2px 0px rgba(96, 97, 112, 0.16), 0px 0px 1px 0px rgba(40, 41, 61, 0.08);', */
  },
  subTitle: {
    fontSize: '0.875rem',
    fontWeight: '600',
    color: colors.grey900,
  },
  videoContainer: {
    width: '100%',
    padding: '1rem',
    borderRadius: '.75rem',
    background: colors.grey200,
  },
  videoIframe: {
    width: '100%',
    height: '100%',
    borderRadius: '.75rem',
  },
  videoWrap: {
    width: '100%',
    height: '100%',
    aspectRatio: '16/9',
    background: colors.grey200,
    borderRadius: '.75rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyLabel: {
    fontSize: '0.875rem',
    fontWeight: '500',
    color: colors.grey700,
  },
  submitButton: {
    margin: '0',
    maxWidth: '240px',
    fontSize: '1.125rem',
    fontWeight: 600,
  },
}));

export default function VideoBannerForm() {
  const classes = useStyles();

  const {setValue} = useFormContext();

  const [url, setUrl] = useState('');

  const youtubeVideoId = useMemo(() => {
    if (!url) return '';
    return extractYoutubeVideoId(url);
  }, [url]);

  const error = url && !youtubeVideoId;

  useEffect(() => {
    const error = url && !youtubeVideoId;
    if (error) return;
    setValue(MAIN_BANNER_FIELDS.VIDEO_URL, url);
    setValue(MAIN_BANNER_FIELDS.VIDEO_ID, youtubeVideoId);

    return () => {
      setValue(MAIN_BANNER_FIELDS.VIDEO_URL, '');
      setValue(MAIN_BANNER_FIELDS.VIDEO_ID, '');
    };
  }, [setValue, url, youtubeVideoId]);

  return (
    <div className={classes.root}>
      <section className={classes.container}>
        <CustomTextField
          placeholder="https://www.youtube.com/watch?v=01Dwftjt2sA"
          value={url}
          onInput={e => {
            setUrl(e.target.value);
          }}
          error={error}
          helperText={error && 'El link no es válido'}
        />

        <div className={classes.videoWrap}>
          {youtubeVideoId && (
            <YoutubePlayer
              videoId={youtubeVideoId}
              style={{
                aspectRatio: '16/9',
              }}
              className={classes.videoContainer}
              iframeClassName={classes.videoIframe}
              opts={{
                playerVars: {
                  autoplay: 1,
                  mute: 1,
                  loop: 1,
                  widget_referrer: 'https://www.google.com/',
                },
              }}
            />
          )}

          {!youtubeVideoId && (
            <Typography className={classes.emptyLabel}>
              El video se mostrará aquí
            </Typography>
          )}
        </div>
      </section>
    </div>
  );
}
